import get from 'lodash/get';
import values from 'lodash/values';
import startCase from 'lodash/startCase';

export const PARTNER_TYPES = {
    partner: 'partner',
    silent: 'silentPartner',
    disabled: 'disabled',
};

export const PARTNER_STATUS = {
    partner: 'trainingPartner',
    silent: 'silentTrainingPartner',
    disabled: 'disabled',
};

export const USER_INTERFACE = {
    engage: 'engage',
    adopt: 'adopt',
};

export const ADOPT_PRODUCT_LINES = {
    adopt: 'adopt',
    adoptReseller: 'adoptReseller',
    adoptEndUser: 'adoptEndUser',
};

// The reason we’re adding 1 to all these is to ensure today is included. So the key for 30 day retention is
// 30 and the actual value is 31 because number needs to include today.
export const RECORDING_RETENTION_DAYS = new Map([
    [7, 8],
    [14, 15],
    [30, 31],
    [90, 91],
]);

export const CLIP_RETENTION_DAYS = {
    default: 366,
    restricted: 31,
};

export const RC_LIMITS = {
    unlimited: -1,
    unlimitedLabel: 'Unlimited',
    limited: 1,
    limitedLabel: 'Limited',
};

export function isNumberOfPublicResourceCentersUnlimited (rcLimit) {
    return rcLimit === RC_LIMITS.unlimited;
}

// startCase mangles acronyms that aren't fully capitalized in the schema (e.g. 'aIGuideContentEnabled'
// splits into 'A I Guide...'), so known field names are overridden here. Keep this in sync with any
// other surface (filter builders, etc.) that displays product line metadata field names.
const METADATA_FIELD_NAME_OVERRIDES = {
    oidcEnabled: 'OIDC Enabled',
    ideas: 'Validate',
    feedback: 'Feedback',
    aIGuideContentEnabled: 'AI Guide Content Enabled',
    aIWritingAssistantEnabled: 'AI Writing Assistant Enabled',
    adoptAnalytics: 'Partner Analytics (Adopt)',
    engageAnalytics: 'Partner Analytics (Pendo UI)',
    email: 'Visitor Email Updates',
    explore: 'Explore (legacy flag)',
    exploreSettings: 'Explore',
    pesEnabled: 'PES and core events enabled',
    replayAiSummaryEnabled: 'Replay AI Summary enabled',
};

export function formatProductLineFieldName (key) {
    const npsFixed = key.includes('nps') ? key.replace('nps', 'NPS ') : key;

    return METADATA_FIELD_NAME_OVERRIDES[key] || startCase(npsFixed);
}

export function getFeedbackUnifiedLoginEnabled (productLine) {
    if (!productLine) {
        return false;
    }

    const isFeedbackPlAndLoginEnabled =
        productLine.type === 'feedback' && get(productLine, 'metadata.unifiedLoginEnabled', false);

    return productLine.purchased && (isFeedbackPlAndLoginEnabled || !!productLine.configured);
}

export function isExtensionEnabledForSubscription (subscription) {
    return isMetadataEnabledForAnyProductLine(subscription.productLines, 'extensionApplicationEnabled');
}

export function isMetadataEnabledForAnyProductLine (productLineMap, metadataName) {
    return values(productLineMap).some((productLine) => {
        return get(productLine, `metadata.${metadataName}`, false);
    });
}

export function useAdoptParityCustomRolesEnabled (adoptEndUserPl, adoptPl) {
    return [adoptEndUserPl, adoptPl].some((pl) => get(pl, 'metadata.useAdoptParityCustomRoles', false));
}

/** listenPremium true = paid Listen (no freemium). Missing defaults to true (premium / legacy). */
export function isVocListenFreemiumActiveFromProductLines (productLines = {}) {
    const vocProductLine = productLines.voc;
    if (!get(vocProductLine, 'purchased')) {
        return false;
    }

    return !get(vocProductLine, 'metadata.freemium.listenPremium', true);
}
